/**
 * Document category ID for Referrals
 * Used in the presign/commit upload flow
 */
export const REFERRALS_CATEGORY_ID = '69846e21213cbccd4529f61e'

/**
 * Maximum number of attachments allowed per referral
 */
export const MAX_ATTACHMENTS = 3
